var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-table" }, [
    _c("table", { staticClass: "b-1-gray-40 wp-10" }, [
      _c("thead", [_c("tr", [_vm._t("header")], 2)]),
      _vm._v(" "),
      _c("tbody", [_vm._t("content")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }